import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs/Rx';

import { ToastController } from 'ionic-angular';

interface NetworkStatusResponse {
  networkAvailabilityStatus: string;
}

@Injectable()
export class NetworkStatusService {

  online$: Observable<boolean>;
  onlineSubject: ReplaySubject<boolean>;

  available: boolean;

  constructor(
    private toastCtrl: ToastController
  ) {

    this.available = true;
    this.onlineSubject = new ReplaySubject(1);
    this.online$ = this.onlineSubject.asObservable();
    this.onlineSubject.next(true);
  }

  getNetworkStatus(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.available = true;
      resolve();
    });
  }

  init(): Observable<void> {
    return new Observable<void>(observer => {

      const self = this;

      function getStatus() {
        self.getNetworkStatus().then(() => {

          setTimeout(() => {
            getStatus();
            observer.next();
          }, 2000);

        });
      }

      getStatus();

      observer.complete();

    });
  }
  presentToast(message) {
    const toast = this.toastCtrl.create({
      message: message,
      position: 'top',
      duration: 4000
    });
    toast.present();
  }

}



// WEBPACK FOOTER //
// ./src/services/network-status.service.ts